import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';
import { ActType } from 'shell/constants/act-type';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';

export const initialValues: CommonInterfaceSubscription = {
  subscriptionBirthData: {
    familyAttribute: '',
  },
  birthdayDocument: {
    actType: ActType.AttoCartaceo,
    digital: emptyDigital,
    paper: emptyPaper,
  },
  familyCoexistence: {
    coexistenceBond: '2',
    progComponent: '',
    bondDate: null,
    membershipDate: null,
    relationship: '',
  },
  person: {
    fiscalCode: '',
    name: '',
    surname: '',
    withoutName: false,
    withoutSurname: false,
  },
  generality: {
    fiscalCode: '',
    name: '',
    surname: '',
    withoutName: false,
    withoutSurname: false,
    istatCode: ISTAT_MILANO,
    subject: '2',
    aire: '',
    anprIdentifier: '',
    birthDate: null,
    isForeign: false,
    italian: {
      municipality: null,
    },
    foreign: {
      municipality: null,
      state: null,
    },
  },
  citizenship: {
    state: null,
    validity: null,
  },
};
